/** @internal */
export function start() {
  require("electron-webpack/dev-runner")
  return Promise.resolve()
}
